import { RecipeMenuOptions } from "./utils/constants";

export const getTimeFormat = (time?: number) => {
  const hour = Math.floor((time ?? 0) / 60);
  const min = (time ?? 0) - hour * 60;
  return { hour, min }
}

export const formattingRecipeTime = (recipeTime: number) => {
  const { hour, min } = getTimeFormat(recipeTime)
  const formattedTime = recipeTime && recipeTime > 60 ? `${hour}h ${min ? min + 'm' : ''}` : `${recipeTime} mins`
  return formattedTime
}

const getOrdinalSuffix = (day: number) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const getDateFormat = (dateTimeString: string) => {
  const date = new Date(dateTimeString);

  const day = date.getDate();
  const monthIndex = date.getMonth();

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const dayWithSuffix = day + getOrdinalSuffix(day);

  const formattedDate = `${dayWithSuffix} ${months[monthIndex]}`;

  return formattedDate;
};

export const options = [
  {
    text: 'Rename',
    type: RecipeMenuOptions.RENAME_RECIPE,
    userCreatedRecipeOption: true,
  },
  {
    text: 'Delete',
    type: RecipeMenuOptions.DELETE_RECIPE,
    userCreatedRecipeOption: true,
  },
  {
    text: 'Share',
    type: RecipeMenuOptions.SHARE_RECIPE,
    userCreatedRecipeOption: false,
  },
  {
    text: 'Copy Ingredients',
    type: RecipeMenuOptions.COPY_INGREDIENTS,
    userCreatedRecipeOption: false,
  }
];